module.exports = __webpack_public_path__ + "img/clock-color.74285736.png";